let base_url = "https://grandswiss1.onrender.com/api/";


export { base_url };



// https://grocery-ecommerce-platform.onrender.com/api/product